import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolunteerIconDark = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "100px",
	width: "100px",
	fill: "#474747",
	"xmlns:x": "http://ns.adobe.com/Extensibility/1.0/",
	"xmlns:i": "http://ns.adobe.com/AdobeIllustrator/10.0/",
	"xmlns:graph": "http://ns.adobe.com/Graphs/1.0/",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		"i:extraneous": "self",
		children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M44,45.2c9.7,0,17.5-7.9,17.5-17.5c0-9.7-7.9-17.5-17.5-17.5c-9.7,0-17.5,7.9-17.5,17.5C26.5,37.3,34.3,45.2,44,45.2z" }) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M78.5,2.5c-4.4-0.4-8,3-8,7.2v4.5c0.3,15.6-3.1,26.8-9.8,32.4c-0.9,0.7-1.7,1.4-2.6,2c-4,2.7-8.9,4.3-14.1,4.3      c-6.1,0-11.6-2.1-16-5.7c-7.3,3.3-13,9.4-13,19.7V91c0,3.6,2.9,6.5,6.5,6.5h45c3.6,0,6.5-2.9,6.5-6.5V66.9c0-0.7,0-1.4-0.1-2.1      c-0.4-5.1,1-10.4,3.8-14.7c5.7-8.7,8.5-20.8,8.2-36v-3.9C85,6.4,82.3,2.9,78.5,2.5z M55.9,75L45.4,85.5c-0.8,0.8-2,0.8-2.7,0      L32.3,75.2c-2.5-2.5-3.1-6.4-1.1-9.3c2.6-3.9,8-4.3,11.1-1.1l1.7,1.7l1.4-1.4c2.5-2.5,6.4-3.1,9.3-1.1      C58.6,66.5,59,71.8,55.9,75z" }) })] })
	}) })
});
export default SvgVolunteerIconDark;
